import usePrefersReducedMotion from './usePrefersReducedMotion'

const useScrollTo = (top = 0) => {
  const isReducedMotionPreferred = usePrefersReducedMotion()

  const scrollTo = () => {
    window.scrollTo({
      top,
      left: 0,
      behavior: isReducedMotionPreferred ? 'instant' : 'smooth',
    })
  }

  return scrollTo
}

export default useScrollTo
